module.exports = __webpack_public_path__ + "static/media/bumble.87817c7c.png";